<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/e2zUNd/tc-custom/9780226163581.jpg?1736425682327" alt="This image is the cover for the book Technology and the Character of Contemporary Life"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Technology and the Character of Contemporary Life
      </h1>
      <p class="bookDescription body article font2">
        <p>Blending social analysis and philosophy, Albert Borgmann maintains that technology creates a controlling pattern in our lives. This pattern, discernible even in such an inconspicuous action as switching on a stereo, has global effects: it sharply divides life into labor and leisure, it sustains the industrial democracies, and it fosters the view that the earth itself is a technological device. He argues that technology has served us as well in conquering hunger and disease, but that when we turn to it for richer experiences, it leads instead to a life dominated by effortless and thoughtless consumption. Borgmann does not reject technology but calls for public conversation about the nature of the good life. He counsels us to make room in a technological age for matters of ultimate concern—things and practices that engage us in their own right.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Albert Borgmann
      </h2>
      
      <p class="authorDescription body article"><B>Albert Borgmann</B> is Regents Professor of Philosophy at the University of Montana. He is the author of <I>Crossing the Postmodern Divide</I>, also published by the University of Chicago Press.<br></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      The University of Chicago Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?39bc0fb6